import { createColumnHelper } from "@tanstack/react-table";

import {
  NULL_DATA_HYPHEN,
  columnHeadersConstants,
  GROUP_PERFORMANCE_LABELS,
} from "../../constants";
import { tableColumns } from "../../../shared-screens/constants";
import { compareNumericString } from "../../../../shared";

const columnHelper = createColumnHelper();
const { SENTIMENT_CHANGE, TRANSACTION_CHANGE } = columnHeadersConstants;

/**
 * Static column definitions for group performance data table.
 */
export const createGroupPerformanceColumns = ({
  cellNameRenderer,
  headerTransactionRatingRenderer,
  headerSurveyCompletionDateRenderer,
  headerSentimentRatingRenderer,
  cellTransactionChangeRenderer,
  cellSentimentChangeRenderer,
}) => [
  columnHelper.accessor("name", {
    header: () => GROUP_PERFORMANCE_LABELS.STORE_NAME,
    cell: cellNameRenderer,
  }),
  columnHelper.accessor("recordCount", {
    header: () => GROUP_PERFORMANCE_LABELS.TOTAL_RESPONSES_COLUMN,
  }),
  columnHelper.accessor("transactionRating", {
    header: headerTransactionRatingRenderer,
  }),
  columnHelper.accessor("previousTransactionRating", {
    header: headerSurveyCompletionDateRenderer,
    minSize: tableColumns.SIZE_200,
    cell: (row) => row.getValue() || NULL_DATA_HYPHEN,
  }),
  columnHelper.accessor("transactionChange", {
    header: () => TRANSACTION_CHANGE,
    enableSorting: true,
    cell: cellTransactionChangeRenderer,
    sortingFn: compareNumericString,
  }),
  columnHelper.accessor("sentimentRating", {
    header: headerSentimentRatingRenderer,
  }),
  columnHelper.accessor("previousSentimentRating", {
    header: headerSurveyCompletionDateRenderer,
    minSize: tableColumns.SIZE_200,
    cell: (row) => row.getValue() || NULL_DATA_HYPHEN,
  }),
  columnHelper.accessor("sentimentChange", {
    header: () => SENTIMENT_CHANGE,
    enableSorting: true,
    cell: cellSentimentChangeRenderer,
    sortingFn: compareNumericString,
  }),
];
